import React from "react";
import { useState } from "react";
import { Container, Image, Offcanvas } from "react-bootstrap";
import { MdArrowForwardIos } from "react-icons/md";
import OffCanvas from "./OffCanvas";
import "./ResponsiveNavbar.scss";
import bestSeller from "../../../assets/best-seller.png";
import New from "../../../assets/new.png";
import New2 from "../../../assets/add-post.png";

const OffCanvasTop = ({ name, parent, showNav, setShowNav }) => {
  const [show, setShow] = useState(false);
  console.log(parent);
  return (
    <>
      <div
        className="me-auto "
        style={{
          fontSize: "0.875rem",
          letterSpacing: "0.125rem",
          borderBottom: "1px solid rgb(232,232,232) ",
          textTransform: "uppercase",
        }}
      >
        {parent?.length > 0 ? (
          <p
            onClick={() => {
              setShow(true);
            }}
            style={{
              lineHeight: "3rem",
              display: "block",
              color: "black",
              fontWeight: "bold",
              paddingLeft: "80px",
            }}
            className="d-flex align-items-center justify-content-between off_canvas_link"
          >
            <div>{name}</div>

            <MdArrowForwardIos style={{ width: "3.375rem" }} />
          </p>
        ) : (
          <p
            className="d-flex align-items-center"
            style={{
              display: "block",
              color: "black",
              lineHeight: "3rem",
              fontWeight: "bold",
              paddingLeft: "30px",
            }}
          >
            <Image
              src={New2}
              alt="icon"
              style={{ width: "30px", height: "30px" }}
              className="me-3"
            />
            {name}
          </p>
        )}
      </div>
      <OffCanvas
        parentName={name}
        data={parent}
        show={show}
        setShow={setShow}
        setShowNav={setShowNav}
      />
    </>
  );
};

export default OffCanvasTop;
